export const PROCESSING_DRIVER_BONUS = "PROCESSING_DRIVER_BONUS";
export const PROCESSING_BULK_DRIVER_BONUS = "PROCESSING_BULK_DRIVER_BONUS";
export const GET_DRIVER_BONUS = "GET_DRIVER_BONUS";
export const CREATE_DRIVER_BONUS = "CREATE_DRIVER_BONUS";
export const DELETE_DRIVER_BONUS = "DELETE_DRIVER_BONUS";
